import {
  IMember,
  INewUser,
  PlatformContextType
} from "@wingspanhq/users/dist/lib/interfaces";
import { InternalAccount } from "@wingspanhq/wingspan-api-sdk";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";
import { selectorIsBusinessTypeOnePerson } from "../../PaymentsSetup/selectors/selectorIsBusinessTypeOnePerson";
import { selectorCanEnableTaxWithholdings } from "./selectorCanEnableTaxWithholdings";

export const selectorProposeTaxWithholdings = (params: {
  user?: INewUser;
  member?: IMember;
  monitoredEntity?: onboardingApiSpec.CustomerEntity;
  internalAccounts?: InternalAccount[];
  isTaxWithholdingEnabled?: boolean;
}) => {
  const { user, member, monitoredEntity, internalAccounts } = params;

  if (!user || !member) {
    return false;
  }

  // Don't show a promotion if user already has tax withholding account in any state. It means they already opted-in
  const hasInternalAccount = internalAccounts?.some(
    account => account.type === "TaxWithholding"
  );

  if (hasInternalAccount) {
    return false;
  }

  // Don't show promotions to payers, only payees should see it
  const hasPayeeContext = user.contexts?.some(
    context => context.type === PlatformContextType.Payee
  );

  if (!hasPayeeContext) {
    return false;
  }

  // Don't show promotions to users who can't enable tax withholdings (US only)
  const canEnableTaxWithholdings = selectorCanEnableTaxWithholdings(
    monitoredEntity,
    member
  );

  if (!canEnableTaxWithholdings) {
    return false;
  }

  // Don't show promotions to users who are not single person business
  const companyStructure = member?.profile.company?.structure;
  const isSinglePersonBusiness =
    selectorIsBusinessTypeOnePerson(companyStructure);

  if (!isSinglePersonBusiness) {
    return false;
  }

  // Finally, check if user has tax withholding enabled
  return !params.isTaxWithholdingEnabled;
};
